// extracted by mini-css-extract-plugin
module.exports = {"stock-return-disabled-alert":"styles_stock-return-disabled-alert__26a3u","page-container":"styles_page-container__37l_t","page-card":"styles_page-card__PayC_"};